export const DEFAULT_CATALOG_KIND = 'domain';

export const allowedEntityKindsList: string[] = [
  'component',
  'product',
  'capability',
  'api',
  'resources',
  'group',
  'template',
  'domain',
  'resource',
  'location',
  'user',
  'groupinfo',
];
